export default __webpack_public_path__ + "static/media/pokeballLower.270a739f.png";